module.exports = __webpack_public_path__ + "img/lr.15d34830.jpg";